export default {
  global: {
    //rServer: "https://www.api-staging.axioscrm.com/",
    rServer: "https://www.admin.sabrinapezzin.be/",
    //rServer: "http://localhost:8000/",
    isMenu: false,
    languages: [
      "french",
      "spanish",
      "english",
      "italian",
      "portuguese",
      "german",
      "dutch",
      "russian",
      "swedish",
      "sweden",
      "norwegian",
    ],
    countries: [
      "france",
      "belgium",
      "spain",
      "portugal",
      "germany",
      "luxembourg",
      "netherlands",
      "russia",
      "sweden",
      "norway",
    ],
  }
};
